var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-category"},[_c('h2',{staticClass:"is-visually-hidden"},[_vm._v("Controls")]),_vm._v(" "),_c('div',{ref:"subcategories",staticClass:"editor-sub-categories"},_vm._l((_vm.subCategories),function(subCategory){return _c('editor-sub-category',{key:subCategory.id,attrs:{"id":subCategory.id,"label":subCategory.label}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd44dc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditorCategory.vue
// module id = null
// module chunks = 